"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const common_components_1 = require("@zapier/common-components");
const fontSize = 14;
const iconSize = 12;
const logoSize = 14;
const previewPillContainerCss = (isClickable) => (Object.assign({ backgroundColor: design_system_1.Colors.grey100, borderRadius: 5, cursor: isClickable ? 'pointer' : 'default', display: 'inline', padding: `1px 4px` }, (isClickable
    ? {
        '&:hover': {
            backgroundColor: design_system_1.Colors.grey200,
        },
        '&:focus': {
            boxShadow: `0 0 0px 2px ${theme_1.Colors.blue500}`,
            outline: 'none',
            padding: `0px 4px`,
        },
    }
    : {})));
const previewPillCss = {
    backgroundColor: design_system_1.Colors.inherit,
    display: 'inline',
    fontSize,
};
const pillLogoContainerCss = {
    position: 'relative',
    top: -1,
};
const pillNameCss = {
    backgroundColor: design_system_1.Colors.inherit,
    color: design_system_1.Colors.black,
    display: 'inline',
    fontWeight: 600,
};
const pillValueCss = {
    backgroundColor: design_system_1.Colors.inherit,
    color: design_system_1.Colors.grey700,
    display: 'inline',
};
const maybeTruncatePillValue = (value) => {
    if (lodash_1.isString(value) && value.length > 30) {
        const start = lodash_1.take(lodash_1.toArray(value), 15).join('');
        const end = lodash_1.takeRight(lodash_1.toArray(value), 15).join('');
        return `${start}…${end}`;
    }
    return value;
};
const getStepLabel = (stepIndex, name) => !lodash_1.isUndefined(stepIndex) && !lodash_1.isNull(stepIndex)
    ? `${stepIndex + 1}. ${name}`
    : name;
const PreviewPill = ({ api, isAutoMapped, onClick, stepIndex, name, value, }) => {
    const onKeyDown = react_1.useCallback(common_utils_1.createKeyHandler(['enter', 'space'], onClick), []);
    const divProps = onClick
        ? {
            onKeyDown,
            onClick,
            tabIndex: 0,
            role: 'combobox',
        }
        : {};
    const label = getStepLabel(stepIndex, name);
    return (core_1.jsx("span", Object.assign({ css: previewPillContainerCss(Boolean(onClick)) }, divProps),
        core_1.jsx("span", { css: previewPillCss },
            core_1.jsx("span", { css: pillLogoContainerCss },
                core_1.jsx(common_components_1.LogoImage, { app: api, backgroundType: "clear", borderPadding: 0, size: logoSize })),
            ' ',
            core_1.jsx("span", { css: pillNameCss },
                label,
                ":"),
            ' ',
            core_1.jsx("span", { css: pillValueCss, title: value }, maybeTruncatePillValue(value)),
            isAutoMapped && (core_1.jsx("span", null,
                ' ',
                core_1.jsx(common_components_1.Icon, { color: theme_1.Colors.steel, name: "wand", size: iconSize }))))));
};
exports.default = PreviewPill;
